<template>
  <div class="question">
    <p class="question-type">{{ questionType }}</p>
    <p class="qustion-title" v-html="data.name"></p>
    <template v-if="choices">
      <ul class="qustion-options">
        <li
          v-for="(item, index) in options"
          :key="item"
          :class="{ active: isAnswer(index) }"
        >
          <span class="option">{{ optionName(index) }}</span>
          <span v-html="item"></span>
        </li>
      </ul>
    </template>
    <template v-else-if="judge">
      <ul class="qustion-options">
        <li :class="{ active: isAnswer(0) }"><span class="option"></span>正确</li>
        <li :class="{ active: isAnswer(1) }"><span class="option"></span>错误</li>
      </ul>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'question',
    props: {
      data: Object,
    },
    computed: {
      questionType() {
        return [
          '【单项选择题】',
          '【多项选择题】',
          '【判断题】',
          '【不定项选择题】',
          '【计算分析题】',
          '【简答题】',
          '【综合题】',
          '【计算问答题】',
          '【案例分析题】',
          '【综合分析题】',
          '【计算题】',
          '【综合分析题】',
          '【计算题】',
        ][this.data.questionOptionType - 1];
      },
      options() {
        return this.data.optionsName.split('|');
      },
      choices() {
        return [1, 2, 4, 12, 13].indexOf(this.data.questionOptionType) !== -1;
      },
      judge() {
        return this.data.questionOptionType === 3;
      },
    },
    methods: {
      optionName(index) {
        return ['A', 'B', 'C', 'D', 'E', 'F'][index];
      },
      isAnswer(index) {
        return this.data.answer.split('|').indexOf(`${index + 1}`) > -1;
      },
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";

.question-type {
  font-size: 15px;
  color: $theme-color;
  line-height: 21px;
}

.qustion-title {
  margin-top: 5px;
  font-size: 16px;
  color: #707070;
  line-height: 24px;
}

.qustion-options > li {
  display: flex;
  align-items: flex-start;
  padding: 10px 0;
  font-size: 14px;
  color: #666;
  line-height: 1.4;
}

.qustion-options > li.active {
  color: $theme-color;
}

.option {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  min-width: 20px;
  height: 20px;
  overflow: hidden;
  font-size: 12px;
  border: 1px solid;
  border-radius: 50%;
}
</style>
